export { MobileEcommLinxInfoLink } from './linx-info-link';
